<template>
  <div class="task-search row" v-if="canRead">
    <div class="advanced-search width-100" style="margin-bottom: 10px">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="tasks-search" class="card col-md-12" style="border: none;">
          <template slot="title">
            <div class="card-header">
              <h4 class="card-title title-black" style="display: inline;">
                Tasks Search
              </h4>
            </div>
          </template>
          <div class="card-body form-group search-card" style="margin-top: 0;">
            <div class="row">
              <div class="col-md-6">
                <label>Search</label>
                <el-input type="search"
                          name="search"
                          clearable
                          placeholder="Search"
                          v-model="query.search"
                          @focus="maybeResetQuerystring"
                          @keyup.enter.native="searchFromPage"
                          v-validate="'minFields'"
                          data-vv-name="search"/>
                <span class="text-danger" v-show="errors.has('search')">
                  {{ mainSearchFieldErrorText }}
                </span>
              </div>
              <div class="col-md-6">
                <button @click="deleteSavedQueries" style="margin-bottom: 0;" class="btn btn-fill btn-info btn-sm btn-save tiny-label-button"> MANAGE </button>
                <label>Saved Searches</label>
                <v-select
                  name="savedQueryName"
                  v-model="selectedSavedQueryName"
                  placeholder="Select from previously saved searches"
                  label="label"
                  value="value"
                  @input="setSelectedSavedQuery"
                  :options="savedQueriesNamesList()">
                </v-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label>Name
                  <span class="text-danger" v-show="errors.has('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <v-select
                  v-model="selectedTaskName"
                  :value="selectedTaskName"
                  @focus="maybeResetQuerystring"
                  @input="setTaskName"
                  placeholder="Search by Task Name"
                  label="label"
                  code="value"
                  v-validate="'minFields'"
                  data-vv-name="search"
                  :options="taskNamesForSelect">
                </v-select>
              </div>
              <div class="col-md-2">
                <label>Departments
                  <span class="text-danger" v-show="errors.has('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <el-select multiple class="select"
                           size="large"
                           @focus="maybeResetQuerystring"
                           @change="setDepartmentIds"
                           placeholder="Department(s)"
                           v-validate="'minFields'"
                           data-vv-name="search"
                           v-model="query.departmentId">
                  <el-option v-for="option in allDepartments"
                             class="select"
                             :value="option.value"
                             :label="option.label"
                             :key="option.label">
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-2">
                <label>PO Number
                  <span class="text-danger" v-show="errors.has('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <el-input type="search"
                          name="poNumber"
                          clearable
                          placeholder="PO Number"
                          v-model="query.poNumber"
                          v-validate="'minFields'"
                          data-vv-name="search"
                          @focus="maybeResetQuerystring"/>
              </div>
              <div class="col-md-2 d-block" style="padding-top: 35px;">
                <p-checkbox style="margin-top: 3px;"
                            name="unassigned"
                            @focus="maybeResetQuerystring"
                            v-validate="'minFields'"
                            data-vv-name="search"
                            v-model="query.unassigned">
                  Find Unassigned
                </p-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <label>Client
                  <span class="text-danger" v-show="errors.has('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <el-autocomplete
                  style="width:100%"
                  class="inline-input"
                  clearable
                  :debounce="150"
                  ref="clientId"
                  v-model="selectedClient"
                  :fetch-suggestions="findClients"
                  :trigger-on-focus="false"
                  value-key="name"
                  placeholder="Client"
                  @select="setClient"
                  @focus="maybeResetQuerystring"
                  @blur="verifyClientAutocompleteSelected"
                  name="clientId"
                  v-validate="'minFields'"
                  data-vv-name="client">
                </el-autocomplete>
                <small class="text-danger" v-show="showInvalidAutocompleteWarning('clientId')">
                  {{ fieldNotValidError('Client') }}
                </small>
              </div>
              <div class="col-md-3">
                <label>Builder
                  <span class="text-danger" v-show="errors.has('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <el-autocomplete
                  style="width:100%"
                  class="inline-input"
                  clearable
                  :debounce="150"
                  v-model="selectedBuilder"
                  ref="builderId"
                  :fetch-suggestions="findBuilders"
                  :trigger-on-focus="false"
                  value-key="name"
                  placeholder="Builder"
                  @focus="maybeResetQuerystring"
                  @blur="verifyBuilderAutocompleteSelected"
                  @select="setBuilder"
                  name="builderId"
                  v-validate="'minFields'"
                  data-vv-name="builder">
                </el-autocomplete>
                <small class="text-danger" v-show="showInvalidAutocompleteWarning('builderId')">
                  {{ fieldNotValidError('Builder') }}
                </small>
              </div>
              <div class="col-md-2">
                <label>Community
                  <span class="text-danger" v-show="errors.has('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <el-autocomplete
                  style="width:100%"
                  class="inline-input"
                  clearable
                  :debounce="150"
                  v-model="selectedCommunity"
                  ref="communityId"
                  :fetch-suggestions="findCommunities"
                  :trigger-on-focus="false"
                  value-key="name"
                  placeholder="Community"
                  @blur="verifyCommunityAutocompleteSelected"
                  @select="setCommunity"
                  name="communityId"
                  v-validate="'minFields'"
                  data-vv-name="community">
                </el-autocomplete>
                <small class="text-danger" v-show="showInvalidAutocompleteWarning('communityId')">
                  {{ fieldNotValidError('Community') }}
                </small>
              </div>
              <div class="col-md-2">
                <label>Permit Number
                  <span class="text-danger" v-show="errors.has('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <el-input type="search"
                          name="permitNumber"
                          clearable
                          placeholder="Permit Number"
                          v-model="query.permitNumber"
                          v-validate="'minFields'"
                          data-vv-name="search"
                          @focus="maybeResetQuerystring"/>
              </div>
              <div class="col-md-2">
                <p-checkbox name="reinspection"
                            @focus="maybeResetQuerystring"
                            v-validate="'minFields'"
                            data-vv-name="search"
                            v-model="query.reinspection">
                  Find Reinspections
                </p-checkbox>
                <p-checkbox
                  v-model="query.excludeInvoiceTasks"
                  name="excludeInvoices"
                  v-validate="'minFields'"
                  data-vv-name="search"
                  @focus="maybeResetQuerystring">
                  Exclude Invoices
                </p-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <label>Priority
                  <span class="text-danger" v-show="errors.has('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <el-select class="select width-100"
                           v-validate="'minFields'"
                           data-vv-name="search"
                           size="large"
                           placeholder="Priority"
                           clearable
                           @focus="maybeResetQuerystring"
                           @clear="clearPriority"
                           v-model="query.priority">
                  <el-option v-for="option in priorities"
                             class="select"
                             :value="option.value"
                             :label="option.label"
                             :key="option.label">
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-2">
                <label>Status
                  <span class="text-danger" v-show="errors.has('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <el-select multiple class="select width-100"
                           size="large"
                           @focus="maybeResetQuerystring"
                           placeholder="Task Status"
                           clearable
                           v-validate="'minFields'"
                           data-vv-name="search"
                           v-model="query.status">
                  <el-option v-for="option in statuses"
                             class="select"
                             :value="option.value"
                             :label="option.label"
                             :key="option.label">
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-2">
                <label>Owner
                  <span class="text-danger" v-show="errors.first('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <v-select
                  class="select-user"
                  v-model="selectedQueryOwner"
                  @focus="maybeResetQuerystring"
                  @input="setQueryOwner"
                  placeholder="Owner"
                  label="label"
                  code="value"
                  v-validate="'minFields'"
                  data-vv-name="search"
                  :options="allUsers">
                </v-select>
              </div>
              <div class="col-md-4">
                <label>Assignees
                  <span class="text-danger" v-show="errors.first('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <v-select
                  class="select-user"
                  v-model="selectedQueryAssignees"
                  @focus="maybeResetQuerystring"
                  @input="setQueryAssignees"
                  placeholder="Assignees"
                  multiple
                  label="label"
                  code="value"
                  v-validate="'minFields'"
                  data-vv-name="search"
                  :options="allUsers">
                </v-select>
              </div>
              <div class="col-md-2">
                <p-checkbox
                  v-model="query.poRequired"
                  name="poRequired"
                  v-validate="'minFields'"
                  data-vv-name="search"
                  @focus="maybeResetQuerystring">
                  PO Required
                </p-checkbox>
                <p-checkbox name="reinspection"
                            @focus="maybeResetQuerystring"
                            v-validate="'minFields'"
                            data-vv-name="search"
                            v-model="query.noPoNumber">
                  No PO Number
                </p-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label>Created Date
                  <span class="text-danger" v-show="errors.first('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <el-date-picker type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="-"
                                start-placeholder="Start date"
                                end-placeholder="End date"
                                v-model="query.createdAt"
                                :format="constants.DATE.FORMAT.DISPLAY"
                                :value-format="constants.DATE.FORMAT.VALUE"
                                :picker-options="datePickerConfig.dateRange"
                                placeholder="Created Date"
                                v-validate="'minFields'"
                                data-vv-name="search"
                                @focus="maybeResetQuerystring" />
              </div>
              <div class="col-md-4">
                <label>Due Date
                  <span class="text-danger" v-show="errors.first('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <el-date-picker type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="-"
                                start-placeholder="Start date"
                                end-placeholder="End date"
                                v-model="query.dueDate"
                                :format="constants.DATE.FORMAT.DISPLAY"
                                :value-format="constants.DATE.FORMAT.VALUE"
                                :picker-options="datePickerConfig.dateRange"
                                placeholder="Due Date"
                                v-validate="'minFields'"
                                data-vv-name="search"
                                @focus="maybeResetQuerystring" />
              </div>
              <div class="col-md-4">
                <label>Completion Date
                  <span class="text-danger" v-show="errors.first('search')">
                    {{ otherSearchFieldErrorText }}
                  </span>
                </label>
                <el-date-picker type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="-"
                                start-placeholder="Start date"
                                end-placeholder="End date"
                                v-model="query.completionDate"
                                :format="constants.DATE.FORMAT.DISPLAY"
                                :value-format="constants.DATE.FORMAT.VALUE"
                                :picker-options="datePickerConfig.dateRange"
                                placeholder="Completion Date"
                                v-validate="'minFields'"
                                data-vv-name="search"
                                @focus="maybeResetQuerystring" />
              </div>
            </div><!-- card content -->
          </div>
          <div class="card-footer" style="height: 50px; font-size: 14px; display: flex; justify-content: flex-end; align-items: center; column-gap: 6px;">
            <p-checkbox v-model="saveQuery" style="padding: 5px 5px 0 0;">
              Save Search
            </p-checkbox>
            <p-checkbox v-model="bigDataChecked" @input="maybeToggleBigDataMode" style="padding: 5px 0 0 0;">
              Big Data Mode
            </p-checkbox>
            <button type="button" @click="clearForm" id="btn-clear" class="btn btn-fill btn-info">
              Clear
            </button>
            <button type="button" @click="searchFromPage" class="btn btn-fill btn-info">
              Search
            </button>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div><!-- end card -->
    <div class="card width-100" style="padding: 5px;">
      <div class="card-body">
        <div class="row" :style="!canDisplayAllTableData ? 'margin-bottom: 10px' : ''">
          <div class="col-md-6">
            <i class="nc-icon nc-alert-circle-i" style="margin: 0 5px 0 10px;"></i>
            <template v-if="canDisplayAllTableData">Completed or Cancelled tasks cannot changed.</template>
            <template v-else>Advanced table features have been disabled to improve performance.</template>
          </div>
          <div class="col-md-2">
            <p-checkbox v-model="ownedByMe" name="ownedByMe">Owned by Me</p-checkbox>
          </div>
          <div class="col-md-2">
            <p-checkbox v-model="assignedToMe" name="assignedToMe">Assigned to Me</p-checkbox>
          </div>
          <div class="col-md-2">
            <div class="pull-right">
              <a @click.prevent="printerFriendly" v-if="hasResults" href="#"><img src="static/img/icon-print.png" title="Print Tasks" class="m-left-12"/></a>
              <a @click.prevent="downloadExcel" v-if="hasResults" href="#"><img src="static/img/icon-excel.jpg" title="Export to Excel" class="m-left-12"/></a>
              <a @click.prevent="handleShowPreferenceModal()" href="#"><img style="width: 26px; height: 26px;" src="static/img/gear-icon.png" title="Configure Columns Displayed" class="m-left-12"/></a>
            </div>
          </div>
        </div>
        <div class="row" v-if="canDisplayAllTableData">
          <div class="col-md-12">
            <div class="bulk-save-container">
              <el-autocomplete
                style="width: 200px; margin-right: 3px;"
                size="large"
                name="assigneeId"
                class="inline-input"
                clearable
                :disabled="!canEditAssignee"
                v-model="selectedAssignAssigneeName"
                :fetch-suggestions="findUsers"
                :trigger-on-focus="false"
                value-key="name"
                placeholder="Assignee"
                @select="setAssignAssigneeId"
                data-vv-scope="bulkAssign">
              </el-autocomplete>
              <el-date-picker
                type="date"
                style="width: 140px; margin: 0 4px;"
                @input="warnIfDueDateIsDayOff"
                :disabled="!canEditDueDate"
                v-model="bulkAssignDate"
                :format="constants.DATE.FORMAT.DISPLAY"
                :value-format="constants.DATE.FORMAT.VALUE"
                :picker-options="datePickerConfig"
                placeholder="Due Date">
              </el-date-picker>
              <small class="text-danger" v-show="errors.has('assigneeId', 'bulkAssign')">
                {{ getError('assigneeId', 'bulkAssign') }}
              </small>
              <el-select class="select width-100"
                         style="width: 140px; margin-right: 3px;"
                         size="large"
                         placeholder="Status"
                         clearable
                         :disabled="!canEditStatus"
                         v-model="selectedStatus">
                <el-option v-for="option in filteredStatuses"
                           class="select"
                           :key="option"
                           :value="option"
                           :label="option">
                </el-option>
              </el-select>
              <button style="margin-top: 7px;" type="button" :disabled="saveButtonDisabled" @click="saveTasks" class="btn btn-fill btn-info">
                Save
              </button>
              <button style="margin-top: 7px;" type="button" :disabled="downloadButtonDisabled" @click="downloadFilesForSelectedTasks" class="btn btn-fill btn-info">
                Download Files
              </button>
              <div class="inline-block" style="margin-left: 3px;">
                <p-checkbox v-model="isPdfsLocked" :disabled="downloadButtonDisabled" name="lockedPdfs">Locked</p-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div v-if="loading" style="text-align: center;">
              <img src="static/img/loading.gif"/>
            </div>
            <el-table class="table-striped wrap-whole-words search-tasks-table indexed-table-column-width"
                      v-else
                      :key="tableKey"
                      id="tasks-table"
                      ref="taskSearchTable"
                      :data="sortedTableData"
                      border
                      :row-style="isOrphanedTask"
                      :header-cell-class-name="headerSortClass"
                      @selection-change="handleSelectionChange"
                      :max-height="tableHeight(300)"
                      style="width: 100%">
              <el-table-column
                :width="indexColumnWidth"
                align="center"
                label="#"
                type="index" />
             <el-table-column
                v-if="canDisplayAllTableData"
                class-name="selection-toggle"
                align="center"
                type="selection"
                width="60">
              </el-table-column>
              <el-table-column v-for="column in filteredTableColumns"
                               :min-width="column.minWidth"
                               :key="column.label"
                               :label="column.label">
                <template v-slot="props">
                  <component v-if="canDisplayAllTableData" :is="column.component" :data="lodash.get(props.row, column.prop)" />
                  <template v-else>
                    {{ column.propBigData ? lodash.get(props.row, column.propBigData) : ' - ' }}
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                v-if="canDisplayAllTableData"
                width="170"
                class="el-table__fixed"
                fixed="right"
                label="Actions">
                <template v-slot="props">
                  <p-button v-if="canReadTask(props.row)" type="success" size="md" icon class="btn-left" title="View/Edit Task">
                    <span class="invisible">Task Id: {{ props.row._id }}</span>
                    <i class="fa fa-edit" @click="handleEditTask(props.row._id)"></i>
                  </p-button>
                  <p-button v-if="canReadJobs" type="success" size="md" icon class="btn-left" title="View/Edit Job">
                    <span class="invisible">Job Id: {{ props.row._source.jobId }}</span>
                    <i class="nc-icon nc-ruler-pencil" @click="handleEditJob(props.row._source.jobId)"></i>
                  </p-button>
                  <p-button v-if="canReadProjects" type="success" size="md" icon class="btn-left" title="View/Edit Project">
                    <span class="invisible">Project Id: {{ props.row._source.projectId }}</span>
                    <i class="nc-icon nc-layout-11" @click="navigateToProject(props.row._source.projectId)"></i>
                  </p-button>
                </template>
              </el-table-column>
              <el-table-column
                v-else
                width="5"
                label="">
                <template></template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="row" style="height: 20px;">
          <div class="col-sm-6">
            <span class="category">Showing {{displayedResultCount}} entries</span>
          </div>
        </div>
        <div class="row" v-if="canTerminateProcessInstance">
          <div class="col-sm-12">
            <button style="margin-top: 7px;" type="button" :disabled="terminateButtonDisabled" @click="confirmTerminateSelected" class="btn btn-fill btn-info">
              Terminate
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {
  assembleTableColumnSortProps,
  autocompleteReady,
  autocompleteTextButNoValue,
  autocompleteTextButNoValueMessage,
  axiosErrorMessage,
  warnIfDueDateIsDayOff,
  filterAndSortTableColumns,
  formatDate,
  getTableHeight,
  notifyError,
  notifySuccess,
  notifyWarning,
  objectBy,
  objectById,
  printModal,
  setIndexColumnWidth,
  sortNested,
  tableHeaderSortCssClass,
  utcToLocalForPatch,
  verifyAutocompleteSelected
} from 'src/utilities/utils'
import Constants from 'src/utilities/constants'
import TableColumns from 'src/utilities/tableColumns'
import lodash from 'lodash'
import {minFields} from 'src/utilities/validation'
import {sync} from 'vuex-pathify'
import Permissions from 'src/utilities/permissions'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {BAD_REQUEST, NOT_FOUND, OK} from 'http-status-codes'
import datePickerConfig from '@/components/UIComponents/DatePicker/datePickerConfig'
import {ptracGet} from '@/utilities/ptracApi'

export default {
  components: {
    vSelect
  },
  computed: {
    query: sync('tasks/search@query'),
    saveQuery: sync('tasks/search/saveQuery@value'),
    user: sync('security/user'),
    isBigData: sync('tasks/search/isBigData'),
    isPdfsLocked: sync('tasks/search/isPdfsLocked'),
    ...mapGetters({
      taskNamesForSelect: 'tasks/names/kvpsForSelect',
      taskNames: 'tasks/names/results',
      taskTemplates: 'tasks/templates/results',
      user: 'security/user',
      userId: 'security/userId',
      allUsers: 'users/kvpsForSelectActiveAndInactivate',
      priorities: 'priorities/ptracTask',
      statuses: 'statuses/ptracTask',
      autocompleteClients: 'companies/autocompleteResultsClient',
      autocompleteBuilders: 'companies/autocompleteResultsBuilder',
      autocompleteCommunities: 'communities/autocompleteResultsCommunity',
      tableData: 'tasks/search/results',
      allDepartments: 'departments/kvpsForSelect'
    }),
    canDisplayAllTableData() {
      return !this.isBigData && this.tableData.length < Constants.ELASTICSEARCH.BIG_DATA_RESULTS_THRESHOLD
    },
    sortedTableData() {
      return this.canDisplayAllTableData ? this.queriedData.sort(sortNested(this.sortedProps)) : this.queriedData
    },
    filteredTableColumns() {
      return filterAndSortTableColumns(this.tableColumns, this.user, Constants.USER_PREFERENCE_TYPES.SEARCH_TASKS)
    },
    filteredStatuses() {
      return [Constants.STATUSES.CANCELLED]
    },
    sortedProps() {
      return assembleTableColumnSortProps(this.filteredTableColumns)
    },
    queriedData() {
      if (!this.ownedByMe && !this.assignedToMe) {
        this.displayedResultCount = this.tableData.length
        return this.tableData
      }
      let filteredCount = 0
      return this.tableData
        .filter((row) => {
          let isIncluded = false

          if (this.assignedToMe) {
            isIncluded = row._source.assigneeId === this.userId;
          }
          if (this.ownedByMe) {
            isIncluded = row._source.ownerId === this.userId;
          }
          if (!isIncluded) {
            filteredCount++
          }
          this.displayedResultCount = (this.tableData.length - filteredCount)
          return isIncluded
        })
    },
    hasResults() {
      return this.tableData && this.tableData.length > 0
    },
    canEditAssignee() {
      return this.$can('edit', Permissions.ASSIGN_TASKS)
    },
    canEditDueDate() {
      return this.$can('edit', Permissions.TASK_DUE_DATE)
    },
    canEditStatus() {
      return this.$can('edit', Permissions.TASKS)
    },
    canRead() {
      return this.$can('read', Permissions.TASKS)
    },
    canReadJobs() {
      return this.$can('read', Permissions.JOBS)
    },
    canReadProjects() {
      return this.$can('read', Permissions.PROJECTS)
    },
    canTerminateProcessInstance() {
      return this.$can('edit', Permissions.TASK_TERMINATE_JOBS_TASKS)
    },
    indexColumnWidth() {
      return setIndexColumnWidth(this.tableData.length)
    }
  },
  data() {
    return {
      activeNames: ['tasks-search'],
      lodash,
      constants: Constants,
      datePickerConfig,
      tableKey: 0,
      city: null,
      streetName: null,
      selectedClient: null,
      selectedBuilder: null,
      selectedTaskName: null,
      selectedCommunity: null,
      selectedQueryAssignees: [],
      selectedQueryOwner: null,
      selectedAssignAssigneeName: null,
      selectedAssignAssigneeId: null,
      selectedStatus: null,
      btnDownloadDisabled: false,
      selectedTasks: [],
      bulkAssignDate: null,
      ownedByMe: false,
      assignedToMe: false,
      displayedResultCount: 0,
      saveButtonDisabled: true,
      downloadButtonDisabled: true,
      terminateButtonDisabled: true,
      mainSearchFieldErrorText: Constants.MESSAGES.AT_LEAST_ONE_FIELD_REQUIRED,
      otherSearchFieldErrorText: '*',
      vvScopes: ['minFields'],
      loading: false,
      tableColumns: TableColumns.TASK_SEARCH,
      isJobSearch: false,
      selectedSavedQueryName: null,
      bigDataChecked: false
    }
  },
  methods: {
    savedQueriesNamesList() {
      return Object.keys(this.user.savedTaskQueries).sort()
    },
    updateSavedQueriesNamesList() {
      this.$forceUpdate()
    },
    headerSortClass({columnIndex}) {
      return tableHeaderSortCssClass(this.filteredTableColumns, columnIndex, 2)
    },
    canReadTask(task) {
      if (this.$can('read', Permissions.TASKS)) {
        // only let standard users edit their own tasks
        if (objectById(this.user.groups, Constants.GROUPS.STANDARD_USERS)) {
          return this.userId === task.assigneeId
        }
        return true
      }
      return false // users not in a group or no access
    },
    navigateToProject(projectId) {
      this.$router.push({path: `/projects/${projectId}`})
    },
    showInvalidAutocompleteWarning(refAndPathName) {
      // $ref has to match prop in store
      return autocompleteTextButNoValue(this, refAndPathName, this.$store.get(`tasks/search/query@${refAndPathName}`))
    },
    fieldNotValidError(field) {
      return autocompleteTextButNoValueMessage(field)
    },
    tableHeight(buffer) {
      return getTableHeight(buffer)
    },
    printerFriendly() {
      this.$eventHub.$emit('show-modal-1', 'Task Search Results', null, '90%')
      printModal('taskSearchResults')
    },
    clearPriority() {
      this.$store.set('tasks/search/query@priority', null)
    },
    downloadExcel() {
      this.$store.dispatch('tasks/search/resultsToExcel',
        {
          columns: this.filteredTableColumns,
          data: this.sortedTableData,
          user: this.user
        }
      )
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    isOrphanedTask(props) {
      if (lodash.get(props, 'row._source.orphaned')) {
        return {backgroundColor: '#fbc658'}
      }
    },
    maybeResetQuerystring() {
      if (this.isJobSearch) {
        this.clearForm()
        this.isJobSearch = false
      }
    },
    clearForm(clearFromSavedQueries = false) {
      if (typeof clearFromSavedQueries !== 'boolean') { // Needed to override click event sent by Clear button
        clearFromSavedQueries = false
      }
      this.$store.set('tasks/search/resetQuery')

      if (!clearFromSavedQueries) {
        this.$store.set('tasks/search/resetResults')
        history.pushState(null, null, '/#/tasks/search')
        this.selectedSavedQueryName = null
        this.saveQuery = false
      }
      this.city = null
      this.selectedQueryAssignees = []
      this.selectedQueryOwner = null
      this.resetClientAndBuilder()
      this.resetCommunity()
      this.$validator.reset()
      this.selectedTaskName = null
      this.isBigData = false
    },
    handleEditTask(taskId) {
      this.$eventHub.$emit('show-modal-2', 'Edit Task', {id: taskId})
    },
    handleEditJob(jobId) {
      this.$eventHub.$emit('show-modal-1', 'Edit Job', {id: jobId}, '80%')
    },
    handleSelectionChange(selectedTasks) {
      this.selectedTasks = selectedTasks
    },
    resetClientAndBuilder() {
      this.selectedClient = null
      this.selectedBuilder = null
    },
    resetCommunity() {
      this.selectedCommunity = null
    },
    async downloadFilesForSelectedTasks() {
      if (this.selectedTasks.length > 100) {
        notifyWarning(this, '100 tasks is the upper limit for downloading task files. Please select fewer tasks and try again.')
        return
      }

      const response = await this.$store.dispatch('files/downloadSelected', this.selectedTasks)
      if (NOT_FOUND === response.status) {
        notifyWarning(this, 'No files were found for the selected tasks')
      } else if (210 === response.status) {
        notifyWarning(this, "The contents of this zip file have a very long file path. If windows encounters errors "
          + "during unzip, try unzipping to the root directory (eg. C:\\) or using a third party tool (7z or winRAR)")
      } else if (OK !== response.status) {
        notifyError(this, 'Failed to download zip archive for selected tasks')
      }
    },
    async saveTasks() {
      const activeTasks = this.eligibleTasksForBulkUpdate()

      if (activeTasks.length < this.selectedTasks.length) {
        notifyWarning(this, this.selectedStatus
            ? 'Can only change status of pending or on-hold tasks.'
            : 'Cannot edit cancelled or completed tasks.'
        )
      }

      if (activeTasks.length < 1 || (!this.selectedAssignAssigneeId && !this.bulkAssignDate && !this.selectedStatus)) {
        return
      }

      const payload = {
        tasks: activeTasks,
        assigneeId: this.selectedAssignAssigneeId || null,
        dueDate: this.bulkAssignDate || null,
        status: this.selectedStatus || null
      }

      const responses = await this.$store.dispatch('tasks/search/bulkUpdate', payload)
      const successResponses = []
      const errorResponses = []

      if (Array.isArray(responses) && responses.length > 0) {
        for (const response of responses) {
          if (response.status === OK) {
            successResponses.push(response.data)
            notifySuccess(this, `Task ${response.data.name} updated successfully`)
          } else if (response.status === BAD_REQUEST || response.status === NOT_FOUND) {
            errorResponses.push(response)
          }
        }

        for (const errorResponse of errorResponses) {
          const failedTaskId = errorResponse.config.url.split("/")
          const failedTask = objectBy(activeTasks, '_id', failedTaskId[failedTaskId.length - 1])
          const errorMessage = {message: axiosErrorMessage(errorResponse)}
          notifyError(this, 'Failed to update task ' + failedTask._source.name, [errorMessage])
        }

        for (const savedTask of successResponses) {
          const taskToUpdate = objectBy(this.selectedTasks, '_id', savedTask.id)

          if (payload.status) {
            taskToUpdate._source.status = payload.status
          }

          if (payload.assigneeId) {
            const newAssignee = objectBy(this.allUsers, 'value', savedTask.assigneeId)
            taskToUpdate._source.assignee = newAssignee.label
          }

          if (payload.dueDate) {
            taskToUpdate._source.dueDate = utcToLocalForPatch(payload.dueDate)
            taskToUpdate._source.dueDateFormatted = formatDate(utcToLocalForPatch(payload.dueDate))
          }
        }

        this.$refs.taskSearchTable.clearSelection()
        this.selectedTasks = []
        this.bulkAssignDate = null
        this.selectedAssignAssigneeId = null
        this.selectedAssignAssigneeName = null
        this.selectedStatus = null
      }
    },
    eligibleTasksForBulkUpdate() {
      return lodash.filter(this.selectedTasks, (taskResult) => taskResult._source.status !== Constants.STATUSES.COMPLETED &&
          taskResult._source.status !== Constants.STATUSES.CANCELLED &&
          (!this.selectedStatus || (taskResult._source.status === Constants.STATUSES.PENDING || taskResult._source.status === Constants.STATUSES.ON_HOLD)))
    },
    resultsNoValidate() {
      this.$store.dispatch('tasks/search/fetchSearchResults')
    },
    async searchFromPage() {
      this.buildUrl()
      await this.searchSubmitFromUrl()
    },
    maybeToggleBigDataMode() {
      this.isBigData = !this.isBigData

      if (this.canDisplayAllTableData) {
        this.tableKey++ //re-render table
      }
    },
    async downloadToExcel() {
      this.$eventHub.$emit('show-modal-1', 'Download To Excel', null, '600px')
      this.loading = true
      await this.$store.dispatch('tasks/search/fetchSearchResultsAndDownloadToExcel', this.filteredTableColumns)
      this.loading = false
    },
    async searchSubmitFromUrl() {
      if (await this.$validator.validateAll()) {
        this.loading = true

        if (this.saveQuery) {
          this.$eventHub.$emit('show-modal-2', 'Save Search', {type: 'Task', query: {...this.query, isBigData: this.isBigData}}, '500px')
        } else {
          this.$eventHub.$emit('show-modal-1', 'Tasks Loading', null, '600px')
        }

        const response = await this.$store.dispatch('tasks/search/fetchSearchResults')
        this.tableKey++ //re-render table
        this.loading = false
        if (response.hits.total.value === 0) {
          this.$eventHub.$emit('show-modal-1', 'No Results Found', null, '500px')
          this.$store.commit('tasks/search/resetResults')
        } else if (this.isBigData) {
          this.$forceUpdate()
          this.bigDataChecked = true
        }
      }
    },
    buildUrl() {
      const fullQuery = this.$store.getters['tasks/search/query']
      const searchParams = []
      Object.keys(fullQuery).forEach(key => {
        const value = fullQuery[key]
        if (value && key !== 'departmentName' && !(Array.isArray(value) && value.length === 0)) {
          lodash.map(value, (val) => {
            return encodeURIComponent(val)
          })
          searchParams.push(`${key}=${value}`)}
      })
      if (searchParams.length > 0) {
        history.pushState(null, null, `/#/tasks/search?${searchParams.join('&')}`)
      }
    },
    handleShowPreferenceModal() {
      const payload = {
        title: 'Search Tasks',
        preferenceType: Constants.USER_PREFERENCE_TYPES.SEARCH_TASKS
      }
      this.$eventHub.$emit('show-modal-1', 'Search and Sort Preferences', payload, '900px')
    },
    findUsers(text, cb) {
      cb(this.$store.getters['users/findByNameStartsWithExcludeInactive'](text))
    },
    setQueryOwner(owner) {
      this.$store.set('tasks/search/query@ownerId', null)
      if (owner) {
        this.$store.set('tasks/search/query@ownerId', owner.value)
      }
    },
    setQueryAssignees(assignees) {
      this.$store.set('tasks/search/query@assigneeIds', null)
      if (assignees) {
        this.$store.set('tasks/search/query@assigneeIds', assignees.map(({ value }) => value))
      }
    },
    setAssignAssigneeId(assignee) {
      if (assignee) {
        this.selectedAssignAssigneeId = assignee.id
        this.warnIfDueDateIsDayOff()
      }
    },
    warnIfDueDateIsDayOff() {
      let payload = {
        assigneeId: null,
        dueDate: null,
        taskName: null,
      }

      if (this.bulkAssignDate && this.selectedAssignAssigneeId) {
        payload.assigneeId = this.selectedAssignAssigneeId
        payload.dueDate = this.bulkAssignDate

        warnIfDueDateIsDayOff(this, payload)
      } else if (this.selectedAssignAssigneeId) {
        for (const task of this.selectedTasks) {
          payload.assigneeId = this.selectedAssignAssigneeId
          payload.dueDate = task._source.dueDate
          payload.taskName = task._source.name

          warnIfDueDateIsDayOff(this, payload)
        }
      } else if (this.bulkAssignDate) {
        for (const task of this.selectedTasks) {
          payload.assigneeId = task._source.assigneeId
          payload.dueDate = this.bulkAssignDate
          payload.taskName = task._source.name

          warnIfDueDateIsDayOff(this, payload)
        }
      }
    },
    findClients(text, cb) {
      this.$store.set('tasks/search/query@clientId', null)
      this.findCompany(text, Constants.COMPANY.TYPES.CLIENT)
      cb(this.autocompleteClients)
    },
    findBuilders(text, cb) {
      this.$store.set('tasks/search/query@builderId', null)
      this.findCompany(text, Constants.COMPANY.TYPES.BUILDER)
      cb(this.autocompleteBuilders)
    },
    findCompany(text, type) {
      if (text) {
        const payload = {
          type: type,
          name: text
        }
        this.$store.dispatch('companies/fetchByNameStartsWithAndType', payload)
      }
    },
    findCommunities(text, cb) {
      this.$store.set('tasks/search/query@communityId', null)
      if (autocompleteReady(text)) {
        this.$store.dispatch('communities/fetchByNameStartsWith', text)
      }
      cb(this.autocompleteCommunities)
    },
    setClient(client) {
      if (client) {
        this.$store.set('tasks/search/query@clientId', client.id)
        this.$store.set('companies/autocompleteResultsClient', [])
        this.$validator.reset()
      }
    },
    verifyClientAutocompleteSelected() {
      verifyAutocompleteSelected(this, 'tasks/search@query.clientId', 'client', this.selectedClient)
    },
    setBuilder(builder) {
      if (builder) {
        this.$store.set('tasks/search/query@builderId', builder.id)
        this.$store.set('companies/autocompleteResultsBuilder', [])
        this.$validator.reset()
      }
    },
    verifyBuilderAutocompleteSelected() {
      verifyAutocompleteSelected(this, 'tasks/search@query.builderId', 'builder', this.selectedBuilder)
    },
    setCommunity(community) {
      if (community) {
        this.$store.set('tasks/search/query@communityId', community.id)
        this.$store.set('communities/autocompleteResultsCommunity', [])
        this.$validator.reset()
      }
    },
    verifyCommunityAutocompleteSelected() {
      verifyAutocompleteSelected(this, 'tasks/search@query.communityId', 'community', this.selectedCommunity)
    },
    setDepartmentIds(departmentId) {
      if (departmentId) {
        const department = []
        departmentId.forEach(dep => {
          department.push(objectBy(this.allDepartments, 'value', dep).label)
        })
        if (department) {
          this.$store.set('tasks/search/query@departmentName', department)
        }
      }
    },
    async setSelectedSavedQuery() {
      this.clearForm(true)
      const selectedSavedQuery = this.user.savedTaskQueries[this.selectedSavedQueryName]

      if (selectedSavedQuery) {
        // Handles nameId, which is no longer a query parameter
        if (selectedSavedQuery.nameId) {
          const savedQueryName = objectById(this.taskNames, selectedSavedQuery.nameId)
          selectedSavedQuery.name = savedQueryName.name
        }

        for (const [key, value] of Object.entries(selectedSavedQuery)) {
          if (key === 'assigneeIds' && value.length > 0) {
            this.query.assigneeIds = value
            value.forEach(assigneeId => {
              this.selectedQueryAssignees.push(objectBy(this.allUsers, 'value', assigneeId))
            })
          } else if (key === 'clientId') {
            const clientResponse = await ptracGet(`companies/${value}`)
            if (clientResponse.status === OK) {
              this.setClient(clientResponse.data)
              this.selectedClient = clientResponse.data.name
            }
          } else if (key === 'builderId') {
            const builderResponse = await ptracGet(`companies/${value}`)
            if (builderResponse.status === OK) {
              this.setBuilder(builderResponse.data)
              this.selectedBuilder = builderResponse.data.name
            }
          } else if (key === 'communityId') {
            const communityResponse = await ptracGet(`communities/${value}`)
            if (communityResponse.status === OK) {
              this.setCommunity(communityResponse.data)
              this.selectedCommunity = communityResponse.data.name
            }
          } else if (key === 'isBigData') {
            this.isBigData = value
            this.bigDataChecked = value
          } else {
            this.query[key] = value
          }
        }

        this.selectedTaskName = objectBy(this.taskNamesForSelect, 'label', selectedSavedQuery.name)
        this.selectedQueryOwner = this.$store.get('users/displayName', selectedSavedQuery.ownerId)
      }
    },
    deleteSavedQueries() {
      this.$eventHub.$emit('show-modal-1', 'Manage Saved Searches', {type: 'Task'}, '40%')
    },
    setTaskName(taskName) {
      this.$store.set('tasks/search/query@name', null)
      if (taskName) {
        this.$store.set('tasks/search/query@name', taskName.label)
      }
    },
    updateEditedTask(task) {
      this.$store.dispatch('tasks/search/updateTaskInSearchResults', task)
    },
    async syncLocalQuery() {
      const clientId = this.$store.get('tasks/search/query@clientId')
      const builderId = this.$store.get('tasks/search/query@builderId')
      const assigneeIds = this.$store.get('tasks/search/query@assigneeIds')
      const communityId = this.$store.get('tasks/search/query@communityId')
      const ownerId = this.$store.get('tasks/search/query@ownerId')
      const name = this.$store.get('tasks/search/query@name')
      if (clientId) {
        const response = await this.$store.dispatch('fetchById', { endpoint: 'companies', id: clientId })
        if (OK === response.status) {
          this.selectedClient = response.data.name
        }
      }
      if (builderId) {
        const response = await this.$store.dispatch('fetchById', { endpoint: 'companies', id: builderId })
        if (OK === response.status) {
          this.selectedBuilder = response.data.name
        }
      }
      if (communityId) {
        const response = await this.$store.dispatch('fetchById', { endpoint: 'communities', id: communityId })
        if (OK === response.status) {
          this.selectedCommunity = response.data.name
        }
      }
      if (name) {
        this.selectedTaskName = objectBy(this.taskNamesForSelect, 'label', name)
      }
      if (ownerId) {
        this.selectedQueryOwner = this.$store.getters['users/displayName'](ownerId)
      }
      if (assigneeIds && assigneeIds.length > 0) {
        assigneeIds.forEach(assigneeId => this.selectedQueryAssignees.push(objectBy(this.allUsers, 'value', assigneeId)))
      }
    },
    setQueryFromUrl() {
      const queryProps = this.$store.get('tasks/search/query')
      const propIsArray = [] //Having a list of query props allows us to identify arrays from url programmatically
      for (let prop in queryProps) {
        if (Array.isArray(queryProps[prop])) {
          propIsArray.push(prop)
        }
      }
      const routeQuery = this.$route.query
      Object.keys(routeQuery).forEach(key => {
        const value = routeQuery[key]
        if (value === 'true') {
          this.$store.set(`tasks/search/query@${key}`, true)
        } else if (propIsArray.includes(key)) {
          this.$store.set(`tasks/search/query@${key}`, value.split(','))
        } else {
          this.$store.set(`tasks/search/query@${key}`, value)
        }

        if (key === 'jobId') {
          this.isJobSearch = true
        }
      })
    },
    confirmTerminateSelected() {
      const activeTasks = lodash.filter(
          this.selectedTasks,
          (taskResult) => taskResult._source.status !== Constants.STATUSES.COMPLETED && taskResult._source.status !== Constants.STATUSES.CANCELLED)

      if (activeTasks.length < this.selectedTasks.length) {
        notifyWarning(this, 'Cannot terminate cancelled or completed tasks.')
      }

      if (activeTasks.length > 100) {
        notifyWarning(this, `Terminating tasks is limited to 100 at a time. You've selected ${activeTasks.length}.`)
        return
      }

      if (activeTasks.length > 0) {
        const data = {
          tasks: activeTasks,
          searchSubmitFromUrl: this.searchSubmitFromUrl
        }
        this.$eventHub.$emit('show-modal-1', 'Terminate Jobs', data, '95%')
      }
    },
    savedSearchClosed(queryName) {
      this.saveQuery = false
      if (queryName && lodash.includes(this.savedQueriesNamesList(), queryName)) {
        this.selectedSavedQueryName = queryName
      }
    }
  },
  mounted() {
    this.$validator.reset()
    minFields('tasks')
    if (this.$route.fullPath.includes('search?')) {
      this.setQueryFromUrl()
      this.searchSubmitFromUrl()
    }
    this.$eventHub.$on('taskSaved', this.updateEditedTask)
    this.$eventHub.$on('savedQueriesNamesList', this.updateSavedQueriesNamesList)
    this.$eventHub.$on('savedSearchClosed', this.savedSearchClosed)
    this.$store.set('address/cities', [])
    this.$store.set('address/streets', [])
    this.syncLocalQuery()
  },
  async beforeCreate() {
    await Promise.all([
      this.$store.cache.dispatch('tasks/names/fetchAll'),
      this.$store.cache.dispatch('tasks/templates/fetchAll'),
      this.$store.cache.dispatch('users/fetchAll'),
      this.$store.cache.dispatch('statuses/fetchByEntityType', 'PtracTask'),
      this.$store.cache.dispatch('priorities/fetchByEntityType', 'PtracTask'),
      this.$store.cache.dispatch('priorities/fetchByEntityType', 'Job'),
      this.$store.cache.dispatch('types/fetchByEntityType', 'Company'),
      this.$store.cache.dispatch('statuses/fetchByEntityType', 'Company')
    ])
  },
  destroyed() {
    this.$eventHub.$off('taskSaved')
    this.$eventHub.$off('savedQueriesNamesList')
    this.$eventHub.$off('savedSearchClosed')

    this.$store.set('tasks/search/isBigData', false)
  },
  watch: {
    filteredTableColumns: function() {
      this.tableKey++
    },
    isBigData(isBigData) {
      this.bigDataChecked = isBigData
    },
    city: {
      handler: function (city) {
        if (!city) {
          this.streetName = null
          this.$store.set('address/cities', [])
          this.$store.set('tasks/search/query@city', null)
          this.$store.set('tasks/search/query@streetName', null)
          this.$validator.reset()
        }
      }
    },
    streetName: {
      handler: function (streetName) {
        if (!streetName) {
          this.$store.set('tasks/search/query@streetName', null)
          this.$validator.reset()
        }
      }
    },
    selectedClient: {
      handler: function (client) {
        if (!client) {
          this.$store.set('tasks/search/query@clientId', null)
          this.$validator.reset()
        }
      }
    },
    selectedBuilder: {
      handler: function (builder) {
        if (!builder) {
          this.$store.set('tasks/search/query@builderId', null)
          this.$validator.reset()
        }
      }
    },
    selectedCommunity: {
      handler: function (communityId) {
        if (!communityId) {
          this.$store.set('tasks/search/query@communityId', null)
          this.$validator.reset()
        }
      }
    },
    selectedTasks: {
      handler: function (selectedTasks) {
        this.saveButtonDisabled = true
        this.downloadButtonDisabled = true
        this.terminateButtonDisabled = true
        if (selectedTasks.length > 0) {
          this.downloadButtonDisabled = false
          this.terminateButtonDisabled = false
          if (this.canEditAssignee || this.canEditDueDate || this.canEditStatus) {
            this.saveButtonDisabled = false
            this.$validator.reset()
          }
          this.warnIfDueDateIsDayOff()
        }
      }
    }
  }
}
</script>
<style scoped>
label {
  display: block;
}
.advanced-search .row {
  margin-bottom: 5px;
}
.bulk-save-container {
  display: inline-block;
}
.search-card {
  font-size: 14px;
  padding: 0;
  margin-top: 15px;
}
.title-black {
  line-height: 35px;
  font-size: 24px;
  color: #252422;
}
#tasks-table .invisible {
  display: none;
}
.task-search >>> .tiny-label-button {
  padding: 1px 5px;
  margin-top: -1px;
  float: right;
}
.select-user >>> .vs__dropdown-menu {
  max-height: 155px;
}
</style>
